export default "__VITE_ASSET__9qODXgBs__"